module.exports = __webpack_public_path__ + "static/media/ElectorateResultsSocial.e1d39660.jpg";